import { render, staticRenderFns } from "./FeaturedImageModal.vue?vue&type=template&id=56879821"
import script from "./FeaturedImageModal.vue?vue&type=script&lang=js"
export * from "./FeaturedImageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports